// reducers/usersReducer.js
import { createSlice } from "@reduxjs/toolkit";
export const usersslice = createSlice({
  name: "user",
  initialState: {
    users: [],
  },
  reducers: {

    Addusers: (state, action) => {
      const incoming = action.payload;
      state.users = Array.isArray(incoming) ? incoming : [];
    },
    AddNewusers: (state, action) => {
      state.users = [ ...state.users, action.payload,];   // takes new user and adds it to the user array
    },
    AddNewuserArray: (state, action) => {
   
      state.users = [ ...action.payload]
    },
    updateusers: (state, action) => {
      let data = action.payload;
      if (!Array.isArray(state.users)) state.users = [];
      let index = state.users.findIndex((obj) => obj._id.toString() === data._id.toString())

      if (index !== -1) {
        state.users[index] = data
      }
      //// console.log(  'redux data',state.users[0])

    },
    deleteuser: (state, action) => {
      const usersId = action.payload;
      if (!Array.isArray(state.users)) state.users = [];
      if (!usersId) return;
      const next = state.users.filter((u) => {
        try { return u?._id?.toString() !== usersId.toString(); } catch { return true; }
      });
      state.users = next;
    },
    deleteusers: (state, action) => {
      let id = action.payload;
      const updateduserss = state.userss.filter(function (users) {
        return users._id !== id;
      });
      state.users = updateduserss;
    },
    editComment: (state, action) => {
      const { usersId, commentId, text } = action.payload;
      let usersIndex = state.users.findIndex((users) => users._id.toString() === usersId.toString());
      if (usersIndex !== -1) {
        let commentIndex = state.users[usersIndex].comments.findIndex((comment) => comment._id.toString() === commentId.toString());
        if (commentIndex !== -1) {
          state.users[usersIndex].comments[commentIndex].text = text;
        }
      }
    },
    userLogout: (state) => {
     state.users = []
    },
  

  },
});

export const selectusers = (state) => state.user.users;

export const { Addusers, AddNewuserArray , updateusers, deleteuser, AddNewusers, deleteComment, editComment , userLogout} = usersslice.actions; // actions
export default usersslice.reducer;